import { render, staticRenderFns } from "./ClientLogin.vue?vue&type=template&id=20d8fb1e&scoped=true&"
import script from "./ClientLogin.vue?vue&type=script&lang=js&"
export * from "./ClientLogin.vue?vue&type=script&lang=js&"
import style0 from "./ClientLogin.vue?vue&type=style&index=0&id=20d8fb1e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d8fb1e",
  null
  
)

export default component.exports